import PageTitle from "@/components/PageTitle";
import SideBarWrapper from "@/components/SideBarWrapper";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Landmark } from "lucide-react";
import { useState } from "react";
import { Listing } from "./Listing";
import { LookupValueMapping } from "@/constants/lookups";

const tabTitles = Object.values(LookupValueMapping);

const Lookups = () => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <SideBarWrapper>
      <div className="LookUpTabs h-full">
        <div className="sidebar-lookups lg:py-5 p-3">
          <h2 className="font-medium text-lg tracking-[-0.08px] mb-3">
            Lookups
          </h2>
          <div className="">
            <TabStrip
              tabPosition={"left"}
              scrollable={true}
              selected={activeTab}
              onSelect={(e) => setActiveTab(e.selected)}
            >
              {tabTitles.map((tile: string, idx: number) => {
                return <TabStripTab title={tile} key={idx} />;
              })}
            </TabStrip>
          </div>
        </div>
        <div className="content-lookups lg:p-5 px-3">
          <div className="card mb-5 p-3 md:block hidden">
            <PageTitle icon={Landmark} pageTitle={tabTitles[activeTab]} />
          </div>
          <Listing lookupType={tabTitles[activeTab]} />
        </div>
      </div>
    </SideBarWrapper>
  );
};

export default Lookups;
